// ———————————————————————————————————————————— SAMPLE GRAPH DATA ——————————————————————————————————————————— //
// ————————————————————————————————————————————————————————————————————————————————————————————————————————— //

/**
 * Large sample network graph data representing organizational relationships
 * Groups:
 * 1 = Example NGOs (sample data)
 * 2 = Zivilgesellschaftliche Organisationen
 * 3 = Stiftungen
 * 4 = Staatliche Institutionen
 * 5 = Wirtschaftliche Akteure
 */

// Helper function to generate random size for sub nodes (default 20-30 range)
function gen_randomNodeSize(min = 10, max = 20) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

// Helper function for nodes with images - ensures minimum size of 50 and maximum of 60 for better visibility
function gen_nodeWithImageSize(min = 50, max = 60) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}

const graphData_v2 = {
  nodes: [
    // Center node
    { id: "center", name: "Welcome Alliance", group: 0, size: 100, type: "boss" },

    // Zivilgesellschaftliche Organisationen (Group 1)
    { id: "zivil_main", name: "Zivilgesellschaftliche\nOrganisationen", group: 2, size: 17.5, type: "main" },

    {
      id: "zivil1",
      name: "Vereine",
      group: 2,
      size: gen_nodeWithImageSize(),
      type: "img",
      quote:
        "Die Welcome Alliance ist eine agile und kluge Solidar- und Hilfsgemeinschaft. Das gemeinsame Wissen von Betroffenen, Expert:innen und Partner:innen kommt im Netzwerk zusammen und führt zu einer gezielten und effizienten Unterstützung. Durch die multidiverse Aufstellung und smarte Entscheidungsprozesse ist die Welcome Alliance nicht nur ihrer Zeit voraus, sondern modellhaft.",
      quote_author: "Derviş Hızarcı",
      quote_role: "Welcome Alliance Ambassador, Vorsitzender der KIgA",
      url_quoteImg: "https://welcome-alliance.org/wp-content/uploads/Dervis-Hizarci-scaled-e1690460606622.jpeg",
    },
    { id: "zivil2", name: "Nichtregierungsorganisationen (NGOs)", group: 2, size: gen_randomNodeSize(), type: "sub" },
    {
      id: "zivil3",
      name: "Initiativen",
      group: 2,
      size: gen_nodeWithImageSize(),
      type: "img",
      quote:
        "Wir schätzen sehr, dass der Welcome Alliance Fund unkompliziert und schnell in soziale Innovationen für die Ankunft und Integration von Geflüchteten investiert. Die Alliance finde ich gleichzeitig ein wertvolles Modell für effektive Koordination in unserer Zivilgesellschaft, auch für zukünftige Krisen.",
      quote_author: "Patrick Hoffmann",
      quote_role: "Generali Deutschland AG; Social Impact & The Human Safety Net",
      url_quoteImg: "https://welcome-alliance.org/wp-content/uploads/Patrick-Hoffmann-–-Generali-Deutschland-AG-Social-Impact-The-Human-Safety-Net.png",
    },
    { id: "zivil4", name: "Bürger:innenbewegungen", group: 2, size: gen_randomNodeSize(), type: "sub" },
    { id: "zivil5", name: "Migrant:innenorganisationen", group: 2, size: gen_randomNodeSize(), type: "sub" },
    {
      id: "zivil6",
      name: "Selbstorganisationen von Geflüchteten",
      group: 2,
      size: gen_nodeWithImageSize(),
      type: "img",
      quote:
        "Obwohl Fluchtbewegungen immer aus Krisen entstehen, ist unsere Fluchthilfe in Deutschland nicht krisenfest. Daher ist es so wichtig, dass die Alliance auch junge und disruptive Ansätze integriert. Dabei gelingt der Austausch aber so, wie wir es uns auch für die Kommunikation mit Ankommenden wünschen: Niedrigschwellig und auf Augenhöhe.",
      quote_author: "Quint Aly",
      quote_role: "Refugee Law Clinics",
      url_quoteImg: "https://welcome-alliance.org/wp-content/uploads/WR6_1334-01-1.jpeg",
    },
    { id: "zivil7", name: "Wohlfahrtsverbände", group: 2, size: gen_randomNodeSize(), type: "sub" },
    { id: "zivil8", name: "Soziale Träger", group: 2, size: gen_randomNodeSize(), type: "sub" },
    { id: "zivil9", name: "Ehrenamtliche Netzwerke", group: 2, size: gen_randomNodeSize(), type: "sub" },
    {
      id: "zivil10",
      name: "Journalisten",
      group: 2,
      size: gen_nodeWithImageSize(),
      type: "img",
      quote:
        "Ich bin mit 15 nach Deutschland gekommen und konnte kein Wort Deutsch. Nicht nur die Sprache, sondern ein neues Land, eine neue Kultur zu verstehen, war so schwer. Heute bin ich Welcome Alliance Ambassador, damit andere es einfacher haben als ich.",
      quote_author: "Nalan Sipar",
      quote_role: "Welcome Alliance Ambassador, freie Journalistin",
      url_quoteImg: "https://welcome-alliance.org/wp-content/uploads/Nalan-Sipar-Quadrat-e1691506646424.jpg",
    },

    // Additional civil society nodes
    { id: "zivil11", name: "Bildungsträger", group: 2, size: gen_randomNodeSize(), type: "sub" },
    { id: "zivil12", name: "Kulturvereine", group: 2, size: gen_randomNodeSize(), type: "sub" },
    { id: "zivil13", name: "Integrationshelfer", group: 2, size: gen_randomNodeSize(), type: "sub" },
    { id: "zivil14", name: "Sprachkurse", group: 2, size: gen_randomNodeSize(), type: "sub" },
    { id: "zivil15", name: "Sozialberatung", group: 2, size: gen_randomNodeSize(), type: "sub" },
    { id: "zivil16", name: "Nachbarschaftshilfe", group: 2, size: gen_randomNodeSize(), type: "sub" },
    { id: "zivil17", name: "Menschenrechtsorganisationen", group: 2, size: gen_randomNodeSize(), type: "sub" },
    { id: "zivil18", name: "Beratungsstellen", group: 2, size: gen_randomNodeSize(), type: "sub" },
    { id: "zivil19", name: "Jugendorganisationen", group: 2, size: gen_randomNodeSize(), type: "sub" },
    { id: "zivil20", name: "Seniorenvereine", group: 2, size: gen_randomNodeSize(), type: "sub" },

    // Stiftungen (Group 2)
    { id: "stift_main", name: "Stiftungen", group: 3, size: 17.5, type: "main" },

    { id: "stift1", name: "Förderstiftungen", group: 3, size: gen_randomNodeSize(), type: "sub" },
    { id: "stift2", name: "Operative Stiftungen", group: 3, size: gen_randomNodeSize(), type: "sub" },
    { id: "stift3", name: "Gemeinnützige Stiftungen", group: 3, size: gen_randomNodeSize(), type: "sub" },
    { id: "stift4", name: "Private Stiftungen", group: 3, size: gen_randomNodeSize(), type: "sub" },
    { id: "stift5", name: "Unternehmensstiftungen", group: 3, size: gen_randomNodeSize(), type: "sub" },

    // Additional foundation types
    { id: "stift6", name: "Bürgerstiftungen", group: 3, size: gen_randomNodeSize(), type: "sub" },
    { id: "stift7", name: "Kirchliche Stiftungen", group: 3, size: gen_randomNodeSize(), type: "sub" },
    { id: "stift8", name: "Bildungsstiftungen", group: 3, size: gen_randomNodeSize(), type: "sub" },
    { id: "stift9", name: "Umweltstiftungen", group: 3, size: gen_randomNodeSize(), type: "sub" },
    { id: "stift10", name: "Sozialstiftungen", group: 3, size: gen_randomNodeSize(), type: "sub" },
    { id: "stift11", name: "Kulturstiftungen", group: 3, size: gen_randomNodeSize(), type: "sub" },
    { id: "stift12", name: "Wissenschaftsstiftungen", group: 3, size: gen_randomNodeSize(), type: "sub" },
    { id: "stift13", name: "Gesundheitsstiftungen", group: 3, size: gen_randomNodeSize(), type: "sub" },

    // Staatliche Institutionen (Group 3)
    { id: "staat_main", name: "Staatliche Institutionen", group: 4, size: 17.5, type: "main" },

    { id: "staat1", name: "Bundesministerien", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat2", name: "Landesministerien", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat3", name: "Kommunale Verwaltungen", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat4", name: "Städte", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat5", name: "Gemeinden", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat6", name: "Behörden", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat7", name: "Öffentliche Ämter", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat8", name: "Öffentliche Einrichtungen", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat9", name: "Staatliche Programme und Initiativen", group: 4, size: gen_randomNodeSize(), type: "sub" },

    // Additional state institutions
    { id: "staat10", name: "Justizministerien", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat11", name: "Bildungsministerien", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat12", name: "Gesundheitsämter", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat13", name: "Arbeitsagenturen", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat14", name: "Wirtschaftsministerien", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat15", name: "Umweltbehörden", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat16", name: "Sozialämter", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat17", name: "Ausländerbehörden", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat18", name: "Schulämter", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat19", name: "Verkehrsbehörden", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat10", name: "Justizministerien", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat11", name: "Bildungsministerien", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat12", name: "Gesundheitsämter", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat13", name: "Arbeitsagenturen", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat14", name: "Wirtschaftsministerien", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat15", name: "Umweltbehörden", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat16", name: "Sozialämter", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat17", name: "Ausländerbehörden", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat18", name: "Schulämter", group: 4, size: gen_randomNodeSize(), type: "sub" },
    { id: "staat19", name: "Verkehrsbehörden", group: 4, size: gen_randomNodeSize(), type: "sub" },

    // Wirtschaftliche Akteure (Group 4)
    { id: "wirtsch_main", name: "Wirtschaftliche Akteure", group: 5, size: 17.5, type: "main" },
    {
      id: "wirtsch1",
      name: "Unternehmen",
      group: 5,
      size: gen_nodeWithImageSize(),
      type: "img",
      quote: "Gemeinsam schaffen wir es von »Made in Germany« zu »Make it in Germany«.",
      quote_author: "Diar Khal",
      quote_role: "Welcome Alliance Ambassador, CEO & Co-Founder von NewStarters",
      url_quoteImg: "https://welcome-alliance.org/wp-content/uploads/Diar.png",
    },
    { id: "wirtsch2", name: "Arbeitgeber:innen", group: 5, size: gen_randomNodeSize(), type: "sub" },
    { id: "wirtsch3", name: "Kleine und mittlere Unternehmen (KMU)", group: 5, size: gen_randomNodeSize(), type: "sub" },
    {
      id: "wirtsch4",
      name: "Großunternehmen",
      group: 5,
      size: gen_nodeWithImageSize(),
      type: "img",
      quote:
        "Die Welcome Alliance leistet wichtige Pionierarbeit für den Aufbau einer effektiven, nachhaltigen, und langfristig angelegten Kriseninfrastruktur, die dazu beiträgt, unsere Gesellschaft und Demokratie auf Krisen vorzubereiten und zu schützen. Google.org unterstützt Project Together, um die Alliance weiter zu skalieren und auszubauen.",
      quote_author: "Rowan Barnett",
      quote_role: "Google.org",
      url_quoteImg: "https://welcome-alliance.org/wp-content/uploads/Rowan-Barnett-Headshot-3.jpeg",
    },
    { id: "wirtsch5", name: "Wirtschaftsverbände", group: 5, size: gen_randomNodeSize(), type: "sub" },
    { id: "wirtsch6", name: "Kammern (z. B. Industrie- und Handelskammern)", group: 5, size: gen_randomNodeSize(), type: "sub" },
    {
      id: "wirtsch7",
      name: "Sozialunternehmen",
      group: 5,
      size: gen_nodeWithImageSize(),
      type: "img",
      quote:
        "Die Welcome Alliance ist ein Vorbild für Netzwerke, die Impulse zur gesellschaftlichen Veränderung setzen wollen. Unsere Ansprechpartner:innen sind kompetent und hoch motiviert; sie bringen die richtigen Partner:innen zusammen, um Synergieeffekte zu erzeugen, und arbeiten ergebnisorientiert. Dadurch können sie nicht nur auf unsere Angebote, sondern auch auf unsere Bedarfe flexibel reagieren.",
      quote_author: "Maryam Gardisi",
      quote_role: "IPSO Care",
      url_quoteImg: "https://welcome-alliance.org/wp-content/uploads/Maryam-Gardisi-–-Ipso-Care-scaled-e1684335911530.jpg",
    },

    // Additional economic actors
    { id: "wirtsch8", name: "Startup-Unternehmen", group: 5, size: gen_randomNodeSize(), type: "sub" },
    { id: "wirtsch9", name: "Handwerksbetriebe", group: 5, size: gen_randomNodeSize(), type: "sub" },
    { id: "wirtsch10", name: "Technologieunternehmen", group: 5, size: gen_randomNodeSize(), type: "sub" },
    { id: "wirtsch11", name: "Beratungsunternehmen", group: 5, size: gen_randomNodeSize(), type: "sub" },
    { id: "wirtsch12", name: "Finanzdienstleister", group: 5, size: gen_randomNodeSize(), type: "sub" },
    { id: "wirtsch13", name: "Personaldienstleister", group: 5, size: gen_randomNodeSize(), type: "sub" },
    { id: "wirtsch14", name: "Gewerkschaften", group: 5, size: gen_randomNodeSize(), type: "sub" },
    { id: "wirtsch15", name: "Arbeitgeberverbände", group: 5, size: gen_randomNodeSize(), type: "sub" },
  ],

  links: [],
};

export default graphData_v2;
